var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';

import './RadioButton.scss';

// @NOTE(jackiechen): readonly is not a valid attribute for input type radio so
// this avoids the propType error that "checked" is set without "onChange"
var onChangeStub = function onChangeStub() {};

var RadioButton = function RadioButton(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$isSelected = _ref.isSelected,
        isSelected = _ref$isSelected === undefined ? false : _ref$isSelected,
        description = _ref.description,
        _ref$hideLabel = _ref.hideLabel,
        hideLabel = _ref$hideLabel === undefined ? false : _ref$hideLabel,
        label = _ref.label,
        name = _ref.name,
        value = _ref.value,
        rest = _objectWithoutProperties(_ref, ['isDisabled', 'isSelected', 'description', 'hideLabel', 'label', 'name', 'value']);

    return React.createElement(
        'div',
        { className: 'radio-container' },
        React.createElement(
            'label',
            { className: 'radio-label' },
            React.createElement('input', _extends({
                disabled: isDisabled,
                name: name,
                onChange: onChangeStub,
                type: 'radio',
                checked: isSelected,
                value: value
            }, rest)),
            React.createElement('span', null),
            React.createElement(
                'span',
                { className: hideLabel ? 'accessibility-hidden' : '' },
                label
            )
        ),
        description ? React.createElement(
            'div',
            { className: 'radio-description' },
            description
        ) : null
    );
};

RadioButton.propTypes = {
    isDisabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    description: PropTypes.node,
    hideLabel: PropTypes.bool,
    label: PropTypes.node.isRequired,
    name: PropTypes.string,
    value: PropTypes.string.isRequired
};
export default RadioButton;
import PropTypes from 'prop-types';